<template>
  <div class="app-menu">
    <div class="app-menu-main elevation-2" :class="{ hide: scroll.position >= 100 && scroll.direction === 'down' }">
      <div class="app-menu-slot" @click="$router.push('/')"><slot /></div>
      <div v-if="!mobile">
        <v-btn v-for="item in menu[language]" :key="item.id" flat :to="item.url" round>{{ item.title }}</v-btn>
      </div>
      <v-speed-dial v-else direction="bottom">
        <v-btn slot="activator" flat fab small aria-label="Menu"><v-icon>mdi-menu</v-icon></v-btn>
        <v-btn v-for="item in menu[language]" :key="`speed-${item.id}`" :to="item.url" color="secondary" round>{{ item.title }}</v-btn>
      </v-speed-dial>
    </div>
    <v-speed-dial v-if="languages.length > 1" fixed bottom right direction="left">
      <v-btn class="app-menu-languages" slot="activator" color="primary" fab>{{ language }}</v-btn>
      <v-btn v-for="item in languages" :key="item" @click="$emit('input', item)" color="secondary" fab small>{{ item }}</v-btn>
    </v-speed-dial>
  </div>
</template>

<script>
export default {
  name: 'app-menu',
  props: {
    languages: { type: Array, default: () => [] },
    language: String,
    scroll: Object
  },
  data: () => ({
    menu: {
      de: [
        { id: 1, url: '/about', title: 'Über uns' },
        // { id: 2, url: '/brands', title: 'Marken' },
        { id: 3, url: '/contact', title: 'Kontakt' }
      ],
      en: [
        { id: 1, url: '/about', title: 'About' },
        // { id: 2, url: '/brands', title: 'Brands' },
        { id: 3, url: '/contact', title: 'Contact' }
      ]
    }
  }),
  computed: {
    mobile () { return this.$vuetify.breakpoint.smAndDown }
  }
}
</script>

<style lang="scss">
@import '../styles/theme';

.app-menu {
  .app-menu-main {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    padding: 12px 0 0 0;
    text-align: center;
    background-color: $COLOR_ACCENT_LIGHT;
    transition: transform .5s ease;

    .app-menu-slot {
      display: inline-block;
      &:hover { cursor: pointer; }
    }

    &.hide { transform: translateY(-110%); }
  }

  .app-menu-languages { margin-left: 8px; }
}
</style>
